import { Slide } from '@features/powerpoint';
import { ValueInput } from '@utils/formattersV2';
import { theme } from '@features/executive-report/domain/theme';
import { formatWithSign } from '@features/executive-report/utils/format-with-sign';
import { OVERALL_LINE_ITEM_OFFSET } from '@features/executive-report/slides/sales-dimensions/texts';

type OverallLineItemTextsOptions = {
  label: string;
  formattedValue: string;
  lift?: number;
  liftFormatter?: (value: ValueInput) => string;
  index: number;
};

export const overallLineItemTexts = (
  options: OverallLineItemTextsOptions
): NonNullable<Slide['texts']> => [
  {
    text: options.label.toUpperCase(),
    options: {
      fontSize: 9,
      color: theme.colors.white,
      h: 0.25,
      w: 2.71,
      x: 0.94,
      y: 3.54 + OVERALL_LINE_ITEM_OFFSET * options.index,
    },
  },
  {
    text: options.formattedValue,
    options: {
      fontSize: 20,
      color: theme.colors.white,
      bold: true,
      h: 0.44,
      w: 1.45,
      x: 0.94,
      y: 3.72 + OVERALL_LINE_ITEM_OFFSET * options.index,
    },
  },
  {
    text: options.liftFormatter
      ? formatWithSign(options.lift, options.liftFormatter)
      : '',
    options: {
      fontSize: 20,
      color: theme.colors.inmarketGreen,
      h: 0.44,
      w: 1.45,
      x: 2.36,
      y: 3.72 + OVERALL_LINE_ITEM_OFFSET * options.index,
    },
  },
];
